<div mat-dialog-title>{{ 'sideMenu.imprint' | translate }}</div>
<div mat-dialog-content>
  <app-imprint class="imprint"></app-imprint>
  <p>
    {{ 'notifications.VERSION' | translate }}:
    <span title="{{ buildInfo }}">{{ versionNumber }}</span>
  </p>
</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>{{ 'common.close' | translate }}</button>
</div>
